module.exports = __webpack_public_path__ + "static/mbl_application.a27f3924.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/engagement/mbl_application.png
// module id = 674
// module chunks = 193162123475590